var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentJobsInternshipsIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0.00598145C43.4616 0.00598145 56 12.5444 56 28.006C56 43.4676 43.4616 56.006 28 56.006C12.5384 56.006 0 43.4676 0 28.006C0 12.5444 12.5384 0.00598145 28 0.00598145Z",
    fill: "#269FB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4239 14.5099H37.0719C39.5471 14.5099 41.5519 16.5147 41.5519 18.9899V37.6379C41.5519 39.8051 39.7991 41.5579 37.6319 41.5579H18.4239C16.2567 41.5579 14.5039 39.8051 14.5039 37.6379V18.4299C14.5039 16.2627 16.2567 14.5099 18.4239 14.5099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6329 25.8108C19.9249 25.8108 18.5361 24.422 18.5361 22.7084C18.5361 20.9948 19.9249 19.606 21.6329 19.606C23.3409 19.606 24.7297 20.9948 24.7297 22.7084C24.7297 24.422 23.3409 25.8108 21.6329 25.8108Z",
    fill: "#269FB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3673 25.8108C32.6593 25.8108 31.2705 24.422 31.2705 22.7084C31.2705 20.9948 32.6593 19.606 34.3673 19.606C36.0753 19.606 37.4641 20.9948 37.4641 22.7084C37.4641 24.422 36.0753 25.8108 34.3673 25.8108Z",
    fill: "#269FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6329 36.4061C19.9249 36.4061 18.5361 35.0173 18.5361 33.3037C18.5361 31.5901 19.9249 30.2013 21.6329 30.2013C23.3409 30.2013 24.7297 31.5901 24.7297 33.3037C24.7297 35.0173 23.3409 36.4061 21.6329 36.4061Z",
    fill: "#269FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3673 36.4061C32.6593 36.4061 31.2705 35.0173 31.2705 33.3037C31.2705 31.5901 32.6593 30.2013 34.3673 30.2013C36.0753 30.2013 37.4641 31.5901 37.4641 33.3037C37.4641 35.0173 36.0753 36.4061 34.3673 36.4061Z",
    fill: "#269FB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentJobsInternshipsIcon2);
export default __webpack_public_path__ + "static/media/student_jobs_internships_icon2.bc62775e311075b48eaaa1fa56d5b2d9.svg";
export { ForwardRef as ReactComponent };